import React, { useState } from "react";

interface ComingSoonProps {
  imagePath?: string | null;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({
  imagePath = null
}) => {
  const [imageError, setImageError] = useState(false);

  if (!imagePath || imageError) {
    return (
      <div className="fixed inset-0 w-full h-full flex items-center justify-center bg-white overflow-hidden">
        <div className="text-center px-8">
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold text-gray-900 mb-6 tracking-tight">
            Coming Soon
          </h1>
          <p className="text-2xl md:text-3xl text-gray-600 font-light">
            Floradibuja
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 w-full h-full bg-white overflow-auto">
      <div className="min-h-full flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12">
        <div className="w-full max-w-7xl">
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={`${imagePath}-desktop.webp`}
              type="image/webp"
            />
            <source
              media="(min-width: 1024px)"
              srcSet={`${imagePath}-desktop.jpg`}
              type="image/jpeg"
            />
            <source
              media="(min-width: 768px)"
              srcSet={`${imagePath}-tablet.webp`}
              type="image/webp"
            />
            <source
              media="(min-width: 768px)"
              srcSet={`${imagePath}-tablet.jpg`}
              type="image/jpeg"
            />
            <source
              media="(max-width: 767px)"
              srcSet={`${imagePath}-mobile.webp`}
              type="image/webp"
            />
            <source
              media="(max-width: 767px)"
              srcSet={`${imagePath}-mobile.jpg`}
              type="image/jpeg"
            />
            <img
              src={`${imagePath}-desktop.jpg`}
              alt="Coming Soon - Floradibuja"
              className="w-full h-auto max-h-[90vh] object-contain"
              loading="eager"
              decoding="sync"
              onError={() => setImageError(true)}
            />
          </picture>
        </div>
      </div>
    </div>
  );
};
